import { Button, Callout } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { generateJiraLink } from 'src/core/modules/jira-issue-reporter/useJiraLink';

export const UnexpectedErrorCallout = () => {
  const { t } = useTranslation('errors');

  return (
    <Callout variant="alert" title={t('unexpectedError.techTitle')}>
      <div className="flex flex-col gap-12">
        {t('unexpectedError.subtitle')}
        <div className="flex items-center gap-12">
          <Button
            className="w-fit"
            id="intercom-message"
            variant="primaryAlert"
            text={t('unexpectedError.contactSupport')}
            onClick={() => window.Intercom('show')}
          />
          {window.Spx && window.Spx.ssdInfo && (
            <Button
              variant="secondaryNeutral"
              href={generateJiraLink({
                companyId: window.Spx.ssdInfo?.companyId,
                companyName: window.Spx.ssdInfo?.companyName,
                userEmail: window.Spx.ssdInfo?.userEmail,
              })}
              target="_about"
              className="flex w-fit items-center text-content-primary"
              text="Create an issue on SSD" // No need for translation here (Only visible for Spendesk's employee)
              component="a"
              iconName="bell-desk"
            />
          )}
        </div>
      </div>
    </Callout>
  );
};
